export const onSelectEffect = (options = {}) => {
  const { sortOptions, onSelect } = options;
  return (e, idx) => {
    const sortOption = sortOptions[idx];
    if (sortOption) {
      onSelect(e, sortOption);
    }
  };
};
